import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { noop } from '@lux/helpers';

import Anchor from '../Anchor';
import { H5, SubtitleSecondary } from '../Base';

const StyledItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${p => p.theme.spacing(4)} 0;
  border-bottom: 1px solid ${p => p.theme.colours.grey_400};

  &:first-of-type {
    padding-top: 0;
  }
`;

const StyledContent = styled.div`
  margin-right: ${p => p.theme.spacing(2)};
`;

const StyledDescription = styled(SubtitleSecondary)`
  color: ${p => p.theme.colours.grey_600};
`;

const StyledActions = styled.div`
  text-align: right;
`;

const CartItem = props => {
  const {
    description,
    showActions,
    price,
    title,
    actionButtonText,
    onActionClick
  } = props;

  return (
    <StyledItem>
      <StyledContent>
        <H5>{title}</H5>
        <StyledDescription as="div">{description}</StyledDescription>
      </StyledContent>
      <StyledActions>
        <SubtitleSecondary>{price}</SubtitleSecondary>
        {showActions && (
          <Anchor
            data-testid={`${title}-action-button`}
            onClick={onActionClick}
          >
            {actionButtonText}
          </Anchor>
        )}
      </StyledActions>
    </StyledItem>
  );
};

CartItem.defaultProps = {
  showActions: true,
  actionButtonText: 'Change',
  onActionClick: noop
};

CartItem.propTypes = {
  description: PropTypes.string,
  showActions: PropTypes.bool,
  title: PropTypes.string,
  actionButtonText: PropTypes.string,
  onActionClick: PropTypes.func
};

export default CartItem;
